module.exports = __webpack_public_path__ + "assets/b3a6381adcda8cbcace2d98a95659470.mp3";